import * as React from 'react';
import { BLACKS_AND_WHITES, STOPLIGHT_COLORS } from '../../utils/DataFormatterUtils';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Popover } from 'antd';

require('color');

const getScoreColors = (score, maxPossibleScore) => {
	let statusColor;
	let statusBackgroundColor;

	if (!score) {
		statusColor = 'lightgray';
		statusBackgroundColor = 'gray';
	} else if (score === maxPossibleScore) {
		statusColor = STOPLIGHT_COLORS.pureGreen;
		statusBackgroundColor = 'rgb(230, 249, 231)';
	} else if (score >= maxPossibleScore * 0.5) {
		statusColor = STOPLIGHT_COLORS.pureYellow;
		statusBackgroundColor = 'rgb(252, 243, 217)';
	} else {
		statusColor = STOPLIGHT_COLORS.pureRed;
		statusBackgroundColor = '#f9e6e6';
	}
	return { statusColor, statusBackgroundColor, score };
};

const getScoreMessage = (score, minPossibleScore, maxPossibleScore) =>
	minPossibleScore === 0
		? `Scored ${score} out of ${maxPossibleScore} possible points`
		: `Scored ${score} on a ${minPossibleScore} to ${maxPossibleScore} scale`;

const WalkthroughScoreDisplay = ({
	scoreObject,
	withPrefix = false,
	style = {},
	isPill = false,
}) => {
	const score = nullSafeGet('score', scoreObject);
	const maxPossibleScore = nullSafeGet('maxPossibleScore', scoreObject);
	const minPossibleScore = nullSafeGetOrElse('minPossibleScore', scoreObject, 0);
	const percentageScore = nullSafeGet('percentageScore', scoreObject);

	if ((!score || !maxPossibleScore) && isPill) return null;

	const { statusColor, statusBackgroundColor } = getScoreColors(score, maxPossibleScore);
	return (
		<div className="flex flex-col">
			<span
				style={{
					...style,
					...(isPill && {
						background: statusBackgroundColor,
						padding: '4px 12px',
						borderRadius: 16,
					}),
				}}
			>
				{score && maxPossibleScore ? (
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
						}}
					>
						<Popover
							content={<div>{getScoreMessage(score, minPossibleScore, maxPossibleScore)}</div>}
						>
							<div
								style={{
									minWidth: 10,
									margin: 0,
								}}
							>
								{withPrefix ? <span className="h5regular mr-2 text-[#4B5563]">Score:</span> : null}
								<span className="h5regular" style={{ marginRight: 2, color: statusColor }}>
									{percentageScore}%
								</span>
							</div>
						</Popover>
					</div>
				) : null}
			</span>
		</div>
	);
};

export default WalkthroughScoreDisplay;

export const WalkthroughScoreLegend = ({ scoreObject, style = {} }) => {
	const score = nullSafeGet('score', scoreObject);
	const maxPossibleScore = nullSafeGet('maxPossibleScore', scoreObject);
	const minPossibleScore = nullSafeGetOrElse('minPossibleScore', scoreObject, 0);

	const { statusColor, statusBackgroundColor } = getScoreColors(score, maxPossibleScore);
	return (
		<span
			style={{
				color: statusColor,
				...style,
			}}
		>
			{score && maxPossibleScore ? (
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
					}}
				>
					<Popover
						content={<div>{getScoreMessage(score, minPossibleScore, maxPossibleScore)}</div>}
					>
						<div
							style={{
								minWidth: 10,
								margin: 0,
							}}
						>
							<div
								className={`h-4 w-4 rounded transition-transform duration-100 hover:scale-105 `}
								style={{
									backgroundColor: statusBackgroundColor,
								}}
							/>
						</div>
					</Popover>
				</div>
			) : (
				<span style={{ color: BLACKS_AND_WHITES.blackSecondary }}>-/-</span>
			)}
		</span>
	);
};
